import cn from '@components/utils/cn'

type SelectionCheckboxProps = {
  checked: boolean
  onChange: () => void
  'aria-label': string
  id?: string
  indeterminate?: boolean
  className?: string
}

export function SelectionCheckbox({
  checked,
  onChange,
  id,
  indeterminate = false,
  className,
  ...aria
}: SelectionCheckboxProps) {
  return (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      ref={(el) => {
        if (el) el.indeterminate = indeterminate
      }}
      onChange={onChange}
      className={cn('tw:h-4 tw:w-4 tw:cursor-pointer tw:rounded tw:border-gray-300 tw:text-primary-600', className)}
      {...aria}
    />
  )
}
